import TypedNativeModules from '../internal/TypedNativeModules';

export async function logScreenViewWithExtraParams(
    screenName: string,
    tags: string[],
    extraParams: Record<string, string | number | boolean>,
): Promise<void> {
    const tareBridge = TypedNativeModules.RNTareBridge;
    if (!tareBridge?.logScreenViewWithExtraParams) {
        return;
    }
    await tareBridge.logScreenViewWithExtraParams(screenName, tags, extraParams);
}
